import useStore from "../../store"
import { useEffect } from "react"
import DashboardContainer from "../common/DashboardContainer"
import RegisterBiometric from "../RegisterBiometric/RegisterBiometric"
import VCIDealers from "./Dealers/VCIDealers"
import Breadcrumbs from "../common/Breadcrumbs"
import FollowUpAudits from "./FieldAudit/FollowUpAudits"
import UploadQueueSummary from "./FieldAudit/UploadQueueSummary"
import { tdeAuditingEnabled } from "../../utilities/featureFlags"

export default function VCIDashboard() {
  const {
    askRegisterBiometric,
    user,
    fetchAuditDealers,
    fetchTrailerLocations,
    setUserLocation,
    breadcrumbTrail,
    setBreadcrumbTrail,
    selectedBranch,
  } = useStore()

  useEffect(() => {
    fetchAuditDealers()
    if (tdeAuditingEnabled) {
      fetchTrailerLocations()
    }
  }, [selectedBranch])

  useEffect(() => {
    if(navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setUserLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        })
      })
    }
  }, [])

  useEffect(() => {
    if(!breadcrumbTrail.some((crumb) => crumb.label === "Field Audits")) {
      const newBreadcrumbTrail = [
        ...breadcrumbTrail,
        {
          label: "Field Audits",
          path: "/field_audits"
        }
      ]
      setBreadcrumbTrail(newBreadcrumbTrail)
    }
  }, [])

  const sidePanels = []

  return(
    <DashboardContainer sidePanels={sidePanels}>
      {askRegisterBiometric && user.type === 'DealerUser' && <RegisterBiometric />}
      <Breadcrumbs/>
      <UploadQueueSummary />
      <VCIDealers />
      <FollowUpAudits />
    </DashboardContainer>
  )
}